import { Button } from '@ixigo/iui/button';
import { Link } from '@tanstack/react-router';

// TODO: update the content of this component
export function NotFound({ children }: { children?: React.ReactNode }) {
	return (
		<div className="space-y-2 p-2">
			<div className="text-secondary">
				{children || <p>The page you are looking for does not exist.</p>}
			</div>
			<p className="flex items-center gap-2 flex-wrap">
				<button
					onClick={() => window.history.back()}
					className="text-primary px-2 py-1 rounded uppercase font-black text-sm"
				>
					Go back
				</button>
				<Button>
					<Link to="/">Start Over</Link>
				</Button>
			</p>
		</div>
	);
}
